import { Navigation } from "@/components/landing/navigation"
import { HeroSection } from "@/components/landing/hero-section"
import { FeaturesSection } from "@/components/landing/features-section.horizontal-scroll"
import { DashboardPreview } from "@/components/landing/dashboard-preview"
import { OpenSourceSection } from "@/components/landing/open-source"
import { Footer } from "@/components/landing/footer"

export default function Home() {
  return (
    <main className="relative isolate min-h-screen bg-[#fafaf9]">
      <div style={{ position: 'relative', zIndex: 1 }}>
        <Navigation />
        <HeroSection />
        <FeaturesSection />
        <div className="hidden md:block">
          <DashboardPreview />
        </div>
        <OpenSourceSection />
        <Footer />
      </div>
    </main>
  )
}
